export default {
    Leadership: 1,
    Intern: 2,
    Teaching: 4,
    CounselorOrLibrarian: 5,
};


// WEBPACK FOOTER //
// ./src/constants/candidate-reference-types.js